
import axios from "axios";
import moment from 'moment';

export const fetchData = async (method, controllerRef) => {
    const apiUrl = process.env.REACT_APP_API_URL;

    let access_token = localStorage.getItem("access_token");
    let headers = {
        "Content-Type": "application/json",
        "Authorization": access_token
    };

    try {
        const response = await axios.get(apiUrl + method, {
            signal: controllerRef.signal,
            headers: headers,
        });
        if (response.data.status == true || response.data.status == "true") {
            return response.data.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error("API Error:", error);
        return null;
    }
}
export const fetchDataPost = async (method, post_data, controllerRef) => {
    const apiUrl = process.env.REACT_APP_API_URL;

    let access_token = localStorage.getItem("access_token");
    let headers = {
        "Content-Type": "application/json",
        "Authorization": access_token
    };
    try {
        const response = await axios.post(apiUrl + method, JSON.stringify(post_data), {
            signal: controllerRef.signal,
            headers: headers
        });
        if (response.data.status == true || response.data.status == "true") {
            return response.data.data;
        } else {
            return [];
        }
    } catch (error) {
        console.error("API Error:", error);
        throw error;
        return null;
    }
}



export const getAccessToken = async (controllerRef) => {
    console.log("getAccessToken ");
    const apiUrl = process.env.REACT_APP_API_URL;
    const username = process.env.REACT_APP_API_USERNAME;
    const password = process.env.REACT_APP_API_PASSWORD;

    let post_data = {
        "username": username,
        "password": password
    };

    let headers = {
        "Content-Type": "application/json",
    };


    try {
        const response = await axios.post(apiUrl + 'login', {
            signal: controllerRef.signal,
            headers: headers,
            body: post_data
        });
        console.log(response);
        if (response.data.status == true || response.data.status == "true") {
            localStorage.setItem("access_token", response.data.token);
            localStorage.setItem("access_token_id", response.data.id);
            var current_time = moment(new Date());
            console.error("current_time " + current_time);
            localStorage.setItem("access_token_expire_in", current_time);

            return response.data.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error("API Error:", error);
        return null;
    }

}

export const checkAccessToken = async (controllerRef) => {
    let token_expire_time = localStorage.getItem("access_token_expire_in");
    if (!token_expire_time) {
        await getAccessToken(controllerRef);
    }
    if (token_expire_time) {
        var current_time = moment(new Date());
        if (current_time.diff(token_expire_time, 'minutes', true) > 50) {
            await getAccessToken(controllerRef);
        }
    }
}